import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  account: {
    description: 'settings.account',
    defaultMessage: 'Account',
    id: 'tncUgG',
  },
  myProfile: {
    description: 'settings.myProfile',
    defaultMessage: 'My Profile',
    id: 'XnCSj6',
  },
  displayOptions: {
    description: 'settings.displayOptions',
    defaultMessage: 'Display Options',
    id: '6VLIxy',
  },
  paymentAndSubscription: {
    description: 'payment and subscription breadcrumb',
    defaultMessage: 'Payment & Subscription',
    id: 'wwVmFw',
  },
  userManagement: {
    description: 'settings.userManagement',
    defaultMessage: 'User Management',
    id: 'DmnZ3b',
  },
  api: {
    description: 'settings.api',
    defaultMessage: 'API Settings',
    id: 'iiZznF',
  },
  senderEmails: {
    description: 'Menu item to manage Sender Emails',
    defaultMessage: 'Sender Emails',
    id: 'NYqi6c',
  },
  signInAndSecurity: {
    description: 'Menu item to manage account settings related to sign in and security',
    defaultMessage: 'Sign In & Security',
    id: '6KubZS',
  },
  workflow: {
    description: 'settings.workflow',
    defaultMessage: 'Workflow Settings',
    id: 'Z3B2bM',
  },
  sellingChannels: {
    description: 'settings.sellingChannels',
    defaultMessage: 'Selling Channels',
    id: 'fVMkm0',
  },
  storeSetup: {
    description: 'settings.storeSetup',
    defaultMessage: 'Store Setup',
    id: 'vdnZiU',
  },
  clients3PL: {
    description: 'settings.clients3PL',
    defaultMessage: 'Clients',
    id: 'h2TmzP',
  },
  automation: {
    description: 'settings.automation',
    defaultMessage: 'Automation',
    id: 'q9sk/v',
  },
  filters: {
    description: 'settings.filters',
    defaultMessage: 'Order Filters',
    id: '4MKH2B',
  },
  smartRoutingRules: {
    description: 'Left Nav Sub Title for using to configure Smart Routing',
    defaultMessage: 'Order Routing',
    id: 'mhIex2',
  },
  automationRules: {
    description: 'settings.automationRules',
    defaultMessage: 'Automation Rules',
    id: 'zVXc34',
  },
  shipping: {
    description: 'settings.shipping',
    defaultMessage: 'Shipping',
    id: 'nqZrN+',
  },
  warehouses: {
    description: 'settings.warehouses',
    defaultMessage: 'Ship From Locations',
    id: 'gOHwdO',
  },
  shippingProviders: {
    description: 'settings.shippingProviders',
    defaultMessage: 'Carriers',
    id: 'KMUa5y',
  },
  fulfillmentProviders: {
    description: 'settings.fulfillmentProviders',
    defaultMessage: 'Fulfillment Providers',
    id: 'CJW3g/',
  },
  freightProviders: {
    description: 'settings.freightProviders',
    defaultMessage: 'Freight Providers',
    id: '5bwXZM',
  },
  insurance: {
    description: 'settings.insurance',
    defaultMessage: 'Insurance',
    id: 'Fa3qSq',
  },
  packages: {
    description: 'settings.packages',
    defaultMessage: 'Packages',
    id: 'hp+i58',
  },
  returns: {
    description: 'settings.returns',
    defaultMessage: 'Returns',
    id: 'Q7lJ0Q',
  },
  international: {
    description: 'settings.international',
    defaultMessage: 'International Settings',
    id: 'J7Yod4',
  },
  printing: {
    description: 'settings.printing',
    defaultMessage: 'Printing',
    id: 'iuHzNu',
  },
  printingSetup: {
    description: 'settings.printingSetup',
    defaultMessage: 'Printing Setup',
    id: 'ID1u5M',
  },
  connect: {
    description: 'settings.connect',
    defaultMessage: 'ShipStation Connect',
    id: '8l2wMD',
  },
  templates: {
    description: 'settings.templates',
    defaultMessage: 'Templates',
    id: 'swVYLd',
  },
  templateLibrary: {
    description: 'settings page where users browse pre-made template library',
    defaultMessage: 'Template Library',
    id: 'fzT93B',
  },
  emailTemplates: {
    description: 'settings.emailTemplates',
    defaultMessage: 'Email Templates',
    id: '5EGN1m',
  },
  packingSlips: {
    description: 'settings.packingSlips',
    defaultMessage: 'Packing Slips',
    id: 'IPW+OC',
  },
  pickList: {
    description: 'settings page where users manages templates for pick list',
    defaultMessage: 'Pick List',
    id: '8wlvY1',
  },
  inventory: {
    description: 'settings.inventory',
    defaultMessage: 'Inventory Management',
    id: 'OrT6O3',
  },
  inventorySettings: {
    description: 'settings.inventorySettings',
    defaultMessage: 'Inventory Settings',
    id: 'f9l7yH',
  },
  allocationStrategy: {
    description: 'settings.allocationStrategy',
    defaultMessage: 'Allocation Strategy',
    id: 'X0WmOZ',
  },
  inventoryWarehouses: {
    description: 'settings.inventoryWarehouses',
    defaultMessage: 'Warehouses',
    id: 'UZn+Zx',
  },
  inventorySources: {
    description: 'settings.inventorySources',
    defaultMessage: 'Inventory Sources',
    id: 'teRq7Z',
  },
  inventorysync: {
    description: 'settings.inventorySync',
    defaultMessage: 'Inventory Sync',
    id: 'qIotEK',
  },
  integrations: {
    description: 'settings.integrations',
    defaultMessage: 'Integrations',
    id: 'BDybbl',
  },
  mailChimp: {
    description: 'settings.integrations.mailChimp',
    defaultMessage: 'MailChimp',
    id: 'Ob9ss+',
  },
  constantContact: {
    description: 'Constant Contact brand name',
    defaultMessage: 'Constant Contact',
    id: 'Ca7YbW',
  },
  eDesk: {
    description: 'settings.integrations.eDesk',
    defaultMessage: 'E-Desk',
    id: '/LmI2c',
  },
  quickbooksOnline: {
    description: 'settings.integrations.quickbooksOnline',
    defaultMessage: 'Quickbooks',
    id: 'F5sshc',
  },
  klaviyo: {
    description: 'settings.integrations.klaviyo',
    defaultMessage: 'Klaviyo',
    id: 'yJ6soF',
  },
  zapier: {
    description: 'settings.integrations.zapier',
    defaultMessage: 'Zapier',
    id: 'q4cKEK',
  },
  returnRabbit: {
    description: 'settings.integrations.returnRabbit',
    defaultMessage: 'ReturnRabbit',
    id: 'rk7UC+',
  },
  gorgias: {
    description: 'settings.integrations.gorgias',
    defaultMessage: 'Gorgias',
    id: 'kjDr0r',
  },
  webhooks: {
    description: 'settings.integrations.webhooks',
    defaultMessage: 'Webhooks',
    id: '1VN4w0',
  },
  shipperHQ: {
    description: 'settings integrations ShipperHQ',
    defaultMessage: 'ShipperHQ',
    id: '67EMcK',
  },
  google: {
    description: 'settings integrations Google',
    defaultMessage: 'Google',
    id: 'eNzE9j',
  },
  amazon: {
    description: 'settings integrations Amazon',
    defaultMessage: 'Amazon',
    id: 'lyp7t0',
  },
  invoices: {
    description: 'settings.subscription.invoices',
    defaultMessage: 'Invoices',
    id: 'yWaVpD',
  },
  archive: {
    description: 'settings subscription label for the archive grid page',
    defaultMessage: 'Archive',
    id: 'JxhLxh',
  },
  integrationPartners: {
    description: 'settings.integrationPartners',
    defaultMessage: 'Integration Partners',
    id: 'NPreFR',
  },
  addOnMarketplace: {
    description: 'settings page for shopping for add-ons',
    defaultMessage: 'Add-Ons',
    id: 'eHEwAc',
  },
  inventoryStrategy: {
    description: 'settings.inventoryStrategy',
    defaultMessage: 'Allocation Strategy',
    id: 'VPzA+a',
  },
  brandedTracking: {
    description: 'settings.brandedTracking',
    defaultMessage: 'Branded Customer Pages',
    id: 'I3ChN4',
  },
  trackingPages: {
    description: 'settings.trackingPages',
    defaultMessage: 'Branding Defaults',
    id: 'yFMQ9k',
  },
  settings: {
    description: 'settings.breadcrumb',
    defaultMessage: 'Settings',
    id: 'w7FwOT',
  },
  selectedStoreSetup: {
    description: 'settings.selectedStoreSetup',
    defaultMessage: 'Selected Store Setup',
    id: 'X9K2Yu',
  },
  emailVerification: {
    description: 'settings email verification',
    defaultMessage: 'Email Verification',
    id: 'OXt6j6',
  },
  orderFilters: {
    description: 'settings order filters',
    defaultMessage: 'Order Filters',
    id: 'Kgw4SA',
  },
  rateShopper: {
    description: 'Link text for the Rate Shopper page',
    defaultMessage: 'Rate Shopper',
    id: '/QjCmO',
  },
  pickupSettings: {
    description: 'settings pickup settings for warehouses label',
    defaultMessage: 'Pickup Settings',
    id: 'ZLVt68',
  },
  transactions: {
    description: 'settings page for viewing transaction history',
    defaultMessage: 'Transactions',
    id: 'WTZkho',
  },
  balance: {
    description: 'settings page for viewing credit/balance information',
    defaultMessage: 'Balance',
    id: 'Rssojy',
  },
  subscription: {
    description: "settings page for viewing a user' subscription to shipstation",
    defaultMessage: 'Subscription',
    id: 'imsNit',
  },
  cancelStamps: {
    description: 'settings page where users can cancel their "Stamps.com" account',
    defaultMessage: 'Cancel Stamps.com',
    id: '/yJ/sx',
  },
  unishippers: {
    description: 'settings unishippers',
    defaultMessage: 'Unishippers',
    id: 'TUwBLH',
  },
  shipsurance: {
    description: 'settings for the shipsurance product',
    defaultMessage: 'Shipsurance',
    id: 'cs39/C',
  },
  checkoutRates: {
    description: 'settings for the checkout rates feature',
    defaultMessage: 'Checkout Rates',
    id: 'nDNIGd',
  },
  updateCarriersHeader: {
    description: 'Header for Carrier update modal',
    defaultMessage: 'Update Carriers and Services',
    id: '0xtVVS',
  },
  continueButton: {
    description: 'continue button text',
    defaultMessage: 'Continue',
    id: 'E/xVtY',
  },
  smartfill: {
    description: 'Feature name for SmartFill to be used in the left nav for seller setting and as the header on the setting page',
    defaultMessage: 'SmartFill',
    id: 'mGKovR',
  },
  labs: {
    description: 'settings.labs',
    defaultMessage: 'Labs',
    id: 'BjIg5m',
  },
  lossPrevention: {
    description: 'settings page for loss prevention features',
    defaultMessage: 'Loss Prevention',
    id: '4Tic2L',
  },
  refundAssist: {
    description: 'Feature name for Refund Assist to be used in the left nav for seller settings and as the header on the setting page',
    defaultMessage: 'Refund Assist',
    id: 'RYhGWr',
  },
  warehouse: {
    description: 'settings.warehouse',
    defaultMessage: 'Warehouse',
    id: '/gTeeC',
  },
  warehousePicking: {
    description: 'settings.warehouse.picking',
    defaultMessage: 'Picking',
    id: '75H4wl',
  },
  warehousePacking: {
    description: 'settings.warehouse.packing',
    defaultMessage: 'Packing',
    id: 'Pb6EnB',
  },
});
